/**
 * 获取埋点上报到券门槛范围
 * @param threshold 券门槛
 * @returns 门槛范围 0-20 上报 0，21-30 上报 1，31-40 上报 2，41-50 上报 3，50+ 上报 4
 */
export function getCouponThresholdRange(thresholdStr: string) {
  /** 券门槛为空，默认 0 */
  const threshold = Number(thresholdStr) || 0;
  if (threshold <= 20) return 0;
  else if (threshold <= 30) return 1;
  else if (threshold <= 40) return 2;
  else if (threshold <= 50) return 3;
  return 4;
}